<template>
  <div class="create-exam">
    <el-dialog
      title="创建考试"
      :visible.sync="createExamShow"
      width="550px"
      :before-close="dialogClose"
      @open="dialogOpen"
    >
      <!-- 考试信息-->
      <div class="create-examInfo">
        <el-form
          ref="ruleForm"
          :rules="rules"
          :model="ruleForm"
          label-width="50px"
          class="content-form"
          label-position="top"
        >
          <el-form-item>
            <el-form-item label="选择年级:" prop="gradeName">
              <el-select
                v-model="ruleForm.gradeName"
                placeholder="请选择年级"
                @change="gradeSelect"
              >
                <el-option
                  :label="item.gradeName"
                  :value="item.gradeId"
                  v-for="(item, index) in gradeList"
                  :key="index"
                ></el-option
              ></el-select>
            </el-form-item>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="主标题:" prop="title">
                <el-select
                  v-model="ruleForm.title"
                  placeholder="请选择主标题"
                  filterable
                  allow-create
                  default-first-option
                >
                  <el-option
                    :label="item"
                    :value="item"
                    v-for="(item, index) in examTitleList"
                    :key="index"
                  ></el-option
                ></el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="副标题:" prop="subTitle">
                <el-input
                  v-model="ruleForm.subTitle"
                  placeholder="请输入副标题"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="开始时间" required>
                <el-form-item prop="startTime">
                  <el-date-picker
                    v-model="ruleForm.startTime"
                    type="datetime"
                    placeholder="请选择开始时间"
                    default-time="09:00:00"
                    value-format="yyyy-MM-dd HH:mm"
                    @change="startTimeChange"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="结束时间" prop="endTime">
                <el-date-picker
                  v-model="ruleForm.endTime"
                  type="datetime"
                  placeholder="请选择结束时间"
                  default-time="11:00:00"
                  value-format="yyyy-MM-dd HH:mm"
                  @change="endTimeChange"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item label="选择学年:" prop="schoolYear">
                <!-- <el-date-picker
                  v-model="ruleForm.schoolYear"
                  type="year"
                  placeholder="选择学年"
                  @change="schoolYearChangeHandle"
                >
                </el-date-picker> -->
                <year-range-picker style="width: 250px;" v-model="ruleForm.schoolYear" />
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item label="选择学期:" prop="semester">
                <el-select v-model="ruleForm.semester" placeholder="请选择学期">
                  <el-option
                    v-for="item in semesterOptions"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
          <el-form-item>
            <el-col :span="11">
              <el-form-item
                label="是否统计"
                label-width="75px"
                prop="isStatistics"
                style="position: relative"
              >
                <el-tooltip
                  effect="dark"
                  content="学生学期素质报告书统计"
                  placement="bottom-start"
                  style="position: absolute; left: 70px; top: -20px"
                >
                  <i class="el-icon-question" style="color: #0362c2"></i>
                </el-tooltip>
                <el-select
                  v-model="ruleForm.isStatistics"
                  placeholder="是否统计"
                >
                  <el-option
                    v-for="item in isStatisticsTypeList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="2">&nbsp;</el-col>
            <el-col :span="11">
              <el-form-item
                label="是否对外"
                label-width="75px"
                prop="isExternal"
                style="position: relative"
              >
                <el-tooltip
                  effect="dark"
                  content="家长是否可看"
                  placement="bottom-start"
                  style="position: absolute; left: 70px; top: -20px"
                >
                  <i class="el-icon-question" style="color: #0362c2"></i>
                </el-tooltip>
                <el-select v-model="ruleForm.isExternal" placeholder="是否对外">
                  <el-option
                    v-for="item in isExternalList"
                    :key="item.dictValue"
                    :label="item.dictLabel"
                    :value="item.dictValue"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-form-item>
        </el-form>
      </div>
      <div class="btn-list">
        <el-button type="primary" @click="confirm">确定</el-button>
        <el-button type="primary" plain @click="dialogClose">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: [
    "createExamShow",
    "semesterOptions",
    "schoolYear",
    "semester",
    "isStatisticsTypeList",
    "isExternalList",
    "examTitleList",
    "gradeList",
  ],
  data() {
    return {
      startTimestamp: "", // 开始时间的时间戳
      endTimestamp: "", // 结束时间的时间戳
      ruleForm: {
        title: "", // 主标题
        subTitle: "", // 副标题
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        isStatistics: "", // 是否统计
        isExternal: "", // 是否对外
        schoolYear: "", // 学年
        semester: "", // 学期
        gradeId: "",
        gradeCode: "",
        gradeName: "", // 年级
      },
      // 表单校验规则
      rules: {
        gradeName: [
          { required: true, message: "请选择年级", trigger: "change" },
        ],
        title: [{ required: true, message: "请选择主标题", trigger: "change" }],
        subTitle: [
          { required: true, message: "请输入副标题", trigger: "blur" },
        ],
        startTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择时间",
            trigger: "change",
          },
        ],
        isStatistics: [
          { required: true, message: "请选择是否统计", trigger: "change" },
        ],
        isExternal: [
          { required: true, message: "请选择是否对外", trigger: "change" },
        ],
        schoolYear: [
          { required: true, message: "请选择学年", trigger: "change" },
        ],
        semester: [
          { required: true, message: "请选择学期", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    // 选择年级
    gradeSelect(e) {
      let currentGrade = this.gradeList.find((item) => item.gradeId == e);
      this.ruleForm = {
        ...this.ruleForm,
        gradeName: currentGrade.gradeName,
        gradeId: currentGrade.gradeId,
        gradeCode: currentGrade.gradeCode,
        schoolId: this.user.schoolId,
        schoolName: this.user.schoolName,
      };
      // console.log("选择年级：", this.ruleForm);
    },
    // 创建考试点击确定
    confirm() {
      // console.log("创建考试点击确定");
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          // console.log("创建考试参数：", this.ruleForm);
          this.post(this.$url.insertGradeExamInfo, this.ruleForm).then((res) => {
            if (res.code !== 200)
              return this.$message.error(res.msg || "创建考试失败");
            // 重置校验规则
            this.$refs["ruleForm"].resetFields();
            this.$message.success(res.msg || "创建考试成功");
            this.$emit("createExamConfirm", this.ruleForm);
          });
        } else {
          return false;
        }
      });
    },
    // 关闭弹出窗口
    dialogClose() {
      // 重置校验规则
      this.$refs["ruleForm"].resetFields();
      this.$emit("update:createExamShow", false);
    },
    // 初始赋值个人信息中的学年学期
    dialogOpen() {
      this.ruleForm = {
        title: "", // 主标题
        subTitle: "", // 副标题
        startTime: "", // 开始时间
        endTime: "", // 结束时间
        isStatistics: "", // 是否统计
        isExternal: "", // 是否对外
        schoolYear: this.schoolYear, // 学年
        semester: this.semester, // 学期
        gradeId: "",
        gradeCode: "",
        gradeName: "", // 年级
      };
      // this.ruleForm.semester = this.semester;
      // this.ruleForm.schoolYear = this.schoolYear;
    },
    // 选择学年
    schoolYearChangeHandle(e) {
      // console.log(e);
      this.ruleForm.schoolYear = e ? "" + e.getFullYear() : "";
    },
    // 选择开始时间
    startTimeChange(e) {
      let timestamp = new Date(e).getTime();
      if (this.endTimestamp != 0 && timestamp >= this.endTimestamp) {
        this.$message.warning("结束时间需大于开始时间");
        // 不修改时间
        return;
      }
      // 时间戳
      this.startTimestamp = timestamp;
    },
    // 选择结束时间
    endTimeChange(e) {
      let timestamp = new Date(e).getTime();
      if (this.startTimestamp != 0 && timestamp <= this.startTimestamp) {
        this.$message.warning("结束时间需大于开始时间");
        return;
      }
      // 时间戳
      this.endTimestamp = timestamp;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./createExamDialog.scss";
</style>